import { useNavigate } from 'react-router-dom';
import logoIP from '../img/logoInfernalParadise.png'
import iconWhatsapp from '../img/iconWhatsApp.png'
import iconTelegram from '../img/iconTelegram.png'

const TarjetScort = ({ scortObjet, preView }) => {

    const navigate = useNavigate();

    const initialImage = scortObjet.currentURL

    const urlWhatsAppMessaje = `https://api.whatsapp.com/send/?phone=+57-${scortObjet.telefono}&text= Hola Infernal Paradise, quiero mas información sobre la modelo ${scortObjet.nombreArtistico} ${scortObjet.apellidoArtistico}, me gustaria contar con sus servicios`
    const urlTelegram = `https://t.me/${scortObjet.usuarioTelegram}`

    const openDetailsScort = () => {
        navigate(`/detail-scort?id=${scortObjet.idProcesamiento}&origin=${preView}`);
    }

    return (
        <>
            <div className='div-target-padre'>
                <div className='div-target'>
                    <img src={initialImage} alt='' className='img-scort-principal' onClick={() => openDetailsScort()}></img>
                </div>
                <div className={preView === 'preliminar' ? "div-icon-ip-preliminar" : "div-icon-ip"}  >
                    <img src={logoIP} alt='' className='img-ip' ></img>
                </div>
                <div className='div-info-scort'>
                    <a style={{ textDecoration: "none" }} href={urlWhatsAppMessaje} target="_blank" rel="noreferrer">
                        <p className='text-info-scort-nombre'>{scortObjet.nombreArtistico} <font>{scortObjet.apellidoArtistico}</font> </p>
                    </a>
                    <div>
                        <a href={urlWhatsAppMessaje} target="_blank" rel="noreferrer">
                            <img src={iconWhatsapp} alt='' className='icon-whastapp' ></img>
                        </a>
                        <a href={urlTelegram} target="_blank" rel="noreferrer">
                            <img src={iconTelegram} alt='' className='icon-telegram' ></img>
                        </a>
                    </div>
                </div>
            </div>
        </>
    )
}

export default TarjetScort